import { PRODUCTION_HOST } from './productionHost';

/**
 * Production hosts that serve the SAME Firebase Hosting site as
 * {@link PRODUCTION_HOST} but are not it: the two Firebase default domains and
 * the legacy custom domain (`app.benenota.ai`, a CNAME to the same site).
 *
 * Why they must not be used: anything bound to the canonical host breaks on
 * them. On 2026-10-20 a user opened the app from an old
 * `benenota-e6b50.web.app` bookmark; Univer's license is bound to
 * `app.bowerlabs.ai`, so every spreadsheet save returned 500 (`license.go:70
 * domain:benenota-e6b50.web.app, check fail`) and 51 saves were lost.
 *
 * EXACT hostnames only. A suffix or pattern match would catch preview channels
 * (`benenota-e6b50--<channel>-<hash>.web.app`), which are production-shaped
 * builds (see `productionHost.ts`) and must keep serving themselves.
 */
export const LEGACY_PRODUCTION_HOSTS: readonly string[] = [
  'benenota-e6b50.web.app',
  'benenota-e6b50.firebaseapp.com',
  'app.benenota.ai',
];

type LocationParts = Pick<Location, 'hostname' | 'pathname' | 'search' | 'hash'>;

/**
 * The canonical URL to send this page to, or `null` to boot normally.
 *
 * `isProduction` is the build's `IS_PROD`, so staging and dev bundles never
 * redirect whatever host serves them. Preview bundles also say production;
 * the exact host match is what keeps them out.
 */
export function canonicalHostRedirectUrl(
  location: LocationParts,
  isProduction: boolean,
): string | null {
  if (!isProduction) return null;
  if (!LEGACY_PRODUCTION_HOSTS.includes(location.hostname)) return null;
  return `https://${PRODUCTION_HOST}${location.pathname}${location.search}${location.hash}`;
}
